/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from "jquery";
window.$ = window.jQuery = $;

// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import './ext';
import('bootstrap').then();

import Vue from "vue";
import axiosPlugin from '@/js/plugins/axios';
Vue.use(axiosPlugin);

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueRouter from "vue-router";
import moment from "moment-timezone";

moment.tz.setDefault("UTC");
import loader from "@/js/components/loader.vue";
import icon from "@/js/components/icon.vue";
import Tooltip from "@/js/components/Tooltip.vue";
import vMultiselect from "@/js/components/Multiselect.vue";
import VueGoogleCharts from "vue-google-charts";
import routes from "@/js/router";
import App from "@/js/views/App.vue";
import "@/js/plugins/notifications";
import "@/js/plugins/constants";
import pinia from '@/js/plugins/pinia';
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueGoogleCharts);
Vue.use(VueRouter);
Vue.prototype.$eventBus = new Vue();

Vue.component("VMultiselect", vMultiselect);
Vue.component("Loader", loader);
Vue.component("Icon", icon);
Vue.component("Tooltip", Tooltip);

const router = new VueRouter({
    mode: "history",
    routes,
});

import r from "@/js/route";
import * as Sentry from "@sentry/vue";
import { useProgressBarStore } from '@/js/store/progress-bar';
import { initAuthService } from '@/js/services/auth-service';

import momentLib from 'moment/moment';
import httpClient from '@/js/services/http-client';
import { hasRole } from '@/js/services/auth-service';
window.moment = momentLib;

/** reload app in case lazy load chunk does not exists*/
router.onError(error => {
    console.log('ERROR', error);
    if (/.*Failed to fetch dynamically imported module.*/i.test(error.message) || /.*Unable to preload CSS.*/i.test(error.message)) {
        window.sessionStorage.setItem('wasReloadedOnError', true);
        window.location.reload()
    }
});

router.beforeEach((to, from, next) => {
    if (typeof to.matched[0]?.components.default === 'function') {
        useProgressBarStore(pinia).start(); // Start progress bar
    }
    if (window.sessionStorage.getItem('wasReloadedOnError') === 'true') {
        window.sessionStorage.setItem('wasReloadedOnError', false);
        const targetPath = window.sessionStorage.getItem('targetPath');
        if (typeof targetPath === 'string') {
            router.push(targetPath);
            return;
        }
    }
    window.sessionStorage.setItem('targetPath', to.path);
    next();
});

router.beforeResolve((to, from, next) => {
    if(to.meta?.permission !== undefined && !app.user.permissions.includes(to.meta?.permission)) {
        router.push({name: '401'});
        return;
    }

    useProgressBarStore(pinia).stop(); // Stop progress bar
    next();
})


if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        Vue,
        dsn: "https://5a9fd45063d6e6d6f4dcc84edeb2a306@sentry-inhouse.servicesmarty.com/5",
        integrations: [
            Sentry.browserTracingIntegration({router}),
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
            }),
            Sentry.browserProfilingIntegration(),
            Sentry.vueIntegration({
                tracingOptions: {
                    trackComponents: true,
                    hooks: ['create', 'mount', 'update', 'destroy']
                }
            })
        ],
        tracesSampleRate: 0.5,
        tracePropagationTargets: [/^https:\/\/exchange\.smartyads\.com/],
        profilesSampleRate: 0.5,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        release: process.env.SENTRY_RELEASE,
        denyUrls: [/extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i]
    });
}

const app = new Vue({
    el: "#app",
    data: () => ({
        countRequests: 0,
        user: {
            id: 0,
            loaded: false,
            name: null,
            role: window.sessionStorage.getItem('userRole'), // back compatibility
            roles: window.sessionStorage.getItem('userRoles').split(',').map( role => ({name: role})   ),
            permissions: window.sessionStorage.getItem('userPermissions').split(','),
            project_settings: JSON.parse(window.sessionStorage.getItem('userProjectSettings') ?? '[]'),
            token: null,
        },
        title: 'AdExchange',
        wideScreen: false,
        largeScreen: false,
    }),
    mounted() {
        const screenWidth = window.innerWidth;
        if ( screenWidth > 600) {
            this.wideScreen = true;
        }
        if (screenWidth >= 992) {
            this.largeScreen = true;
        }
    },
    created() {
        initAuthService(this);
        // загружаем данные, когда представление создано
        // и данные реактивно отслеживаются
        this.getUserRole();
    },
    methods: {
        setTitle(title = '') {
            document.querySelector("title").innerText = `${title} | ${import.meta.env.VITE_APP_NAME} AdExchange`
        },
        getUserRole() {
            this.$root.userPromise = new Promise((resolve, reject) => {
                httpClient.post(r('getAuthUser')).then(({ data }) => {
                    this.$root.user.id = data.id;
                    this.$root.user.loaded = true;
                    this.$root.user.name = data.name;
                    this.$root.user.roles = data.roles.map(i => i.name);
                    this.$root.user.permissions = data.permissions;
                    this.$root.user.project_settings = data.project_settings;
                    this.$root.user.email = data.email;
                    this.$root.user.token = data.token;
                    // Sentry.setUser({
                    //     id: data.id,
                    //     username: data.name
                    // });
                    resolve(this.$root.user);
                }).catch(() => {
                    this.$root.user.id = 0;
                    this.$root.user.loaded = false;
                    this.$root.user.name = null;
                    this.$root.user.roles = null;
                    this.$root.user.permissions = [];
                    this.$root.user.project_settings = [];
                    this.$root.user.email = null;
                    this.$root.user.token = null;
                    reject(this.$root.user);
                });

            })
        },
        hasPermission(permission) {
            return this.user.permissions.includes(permission);
        },
        getProjectSetting(key) {
            return this.user.project_settings.find(i => i.key === key)?.value
        },

        //hasRole(user with roles, needleRole or array of Needle roles, allRoles required or some of role in needle role array)
        //hasRole(user, ['dev', 'manager']) = true/false
        //hasRole(user, 'dev') = true/false
        hasRole(user, name, requireAll = false) {
            if (Array.isArray(name)) {
                if (name.length === 0) {
                    return true;
                }
                for (const roleName of name) {
                    let hasRole = this.hasRole(user, roleName);
                    if (hasRole && !requireAll) {
                        return true;
                    } else if (!hasRole && requireAll) {
                        return false;
                    }
                }
                return requireAll;
            }
            return user.roles.some(role => {
               if(typeof role === 'string') {
                   return role === name;
               }
               return  role.name === name
            });
        },
    },
    render: (h) => h(App),
    router,
    pinia
});
